import React from 'react';
import localize from '../localize';
import NavLinkScrollTop from '../NavLinkScrollTop';
import './FooterButton.css';

export default localize()(({ i18n, dest }) => (
	<div className="text-center footer-button">
	  <h1>{ i18n.t('header') }</h1>
	  <hr className="centered" />
	  <h2>
	    <NavLinkScrollTop to={dest}>
	      { i18n.t('action') }<br />
	      <q-icon size="md" name="long-arrow-right"></q-icon>
	    </NavLinkScrollTop>
	  </h2>
	</div>
));


// WEBPACK FOOTER //
// ./src/components/FooterButton/index.js